import React, { useEffect } from "react";
import styled from "styled-components";

const Code = styled.div`
color: #fff;
padding: 1rem;
width: 100%;
white-space: pre-wrap;
font-size: 10px;
line-height: 1.1;

@media (min-width: 768px) {
  font-size: 16px;
  line-height: 1.2;
}
font-family: source-code-pro, monospace;
font-weight: 400;
font-style: normal;
`;

const textlines = [
  "SAKOKU [Walled Garden] Project", "by YCAM + Kyle McDonald", "version 1.0",
  "                                                 ., .",
  "           ,          ..ifLf1:                  ..,, ",
  "          ;Ci:.     :C0@@0@@@@Gi ......,,,....,:, :; ",
  "  .    .1CCttCL;   ,0f80fLG0@@@@L..            ,,.,; ",
  "  ...   ,,   .     1@8L      t@@@1             ., ,i ",
  "    .,,    ..  . . f@8  .   . :;8C  ..........,,. ,i ",
  "  ,:   ,,....... . ;@i         ;@t  ,:,:;i,i;:i;. .i ",
  "  ,GL1..,           10t,      t@@Ci .:,,ii,i;:i;. .1 ",
  "   LCG,., ,::;;    ,tL@8i    .8CLLfi,..,::,::,,:, .1 ",
  "   tGC, , C@@@@,   iffLG8,    tLGfLfi:...,;:i;::, .1 ",
  "   ;CL: , f@8@@:  .fGfGCLt,  ;fCLCGffftt;.;;;i;;, .t.",
  "    ..  : 1@@@@1;tLfCGCGLfL1iffLGLffffffti.,:::,,  t.",
  "        , i@@@GfLLffffLLfffLLffffttffftftf,,,.  ,  t.",
  "        , :000ffffLLffffffffffffffffLGtttt;...  .. f,",
  "     .. ,.  .,fffff0GffLfffffffffffff0Lt11t,,  .   i,",
  "            .,fftttL@LffffffLLLffffffLLfftti,   .   "
]

const Boot = ({ finished }) => {
  useEffect(() => {
    let code = document.getElementById('code');
    let rowLength = textlines.length;
    let textLength;
    let content = "";
    let col = 0;
    let row = 0;
    const TYPE_SPEED = 5;

    function type() {
      code.innerHTML = content + "_";
      textLength = textlines[row].length;
      if(col < textLength) {
        content = content + textlines[row][col];
        col++;
        setTimeout(type, TYPE_SPEED);
      } else {
        if(row < rowLength - 1) {
          content = content + '<br />';
          col = 0;
          row++;
          setTimeout(type, TYPE_SPEED);
        } else {
          setTimeout(finished, 500);
        }
      }
    }

    setTimeout(type, TYPE_SPEED);
  }, [finished])

  return (
    <Code id="code"></Code>
  )
}

export default Boot;
